export enum ErrorsActionTypes {
  TO_ERROR_PAGE = '[Errors] To errors page',
  LOG_ERROR_TO_BACKAND = '[Errors] log error to backand',
}
